<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
            <v-btn
                v-on="on"
                icon
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </template>

        <UserForm
            @settingsIsProcessed="done"
            @settingsIsCanceled="close"
        ></UserForm>
    </v-dialog>
</template>

<script>
  import UserForm from './UserForm'

  export default {
    name: 'UserFormDialog',
    components: { UserForm },
    data: () => ({
      dialog: false
    }),
    methods: {
      done () {
        this.dialog = false
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>
